import {
    FETCH_DEVICE_INFO_START,
    FETCH_DEVICE_INFO_SUCCESS,
    FETCH_DEVICE_INFO_FAIL,
    FETCH_USER_DEVICE_INFO_START,
    FETCH_USER_DEVICE_INFO_SUCCESS,
    FETCH_USER_DEVICE_INFO_FAIL,
    REMOVE_DEVICE_START,
    REMOVE_DEVICE_SUCCESS,
    REMOVE_DEVICE_FAIL,
    FETCH_DEVICE_INFO_BY_DEVICE_VERSION_PK,
    FETCH_DEVICE_INFO_BY_DEVICE_VERSION_PK_START,
    FETCH_DEVICE_INFO_BY_DEVICE_VERSION_PK_SUCCESS,
    FETCH_DEVICE_INFO_BY_DEVICE_VERSION_PK_FAIL
} from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    deviceInfo: null,
    deviceInfoFetching: false,
    deviceInfoSuccess: false,
    deviceInfoFail: false,
    removingDevice: false,
    removeDeviceSuccess: false,
    removeDeviceFail: false,
    userDeviceInfo: null,
    userDeviceInfoFetching: false,
    userDeviceInfoSuccess: false,
    userDeviceInfoFail: false,
    deviceInfoByVersionPk: null,
    deviceInfoByVersionPkFetching: false,
    deviceInfoByVersionPkSuccess: false,
    deviceInfoByVersionPkFail: false
};

const deviceInfoFetching = (state) => ({
    ...state,
    deviceInfoFetching: true
});

const deviceInfoFetchFinished = (isSuccess) => (state, action) => ({
    ...state,
    deviceInfo: isSuccess ? action.data : null,
    deviceInfoFetching: false,
    deviceInfoSuccess: isSuccess,
    deviceInfoFail: !isSuccess
});

const userDeviceInfoFetching = (state) => ({
    ...state,
    userDeviceInfoFetching: true
});

const userDeviceInfoFetchFinished = (isSuccess) => (state, action) => ({
    ...state,
    userDeviceInfo: isSuccess ? action.data : null,
    userDeviceInfoFetching: false,
    userDeviceInfoSuccess: isSuccess,
    userDeviceInfoFail: !isSuccess
});

const deviceInfoByVersionPkFetching = (state) => ({
    ...state,
    deviceInfoByVersionPkFetching: true
});

const deviceInfoByVersionPkFinished = (isSuccess) => (state, action) => ({
    ...state,
    deviceInfoByVersionPk: isSuccess ? action.data : null,
    deviceInfoByVersionPkFetching: false,
    deviceInfoByVersionPkSuccess: isSuccess,
    deviceInfoByVersionPkFail: !isSuccess
});

export const isDeviceInfoFetching = (state) => state.deviceInfo.deviceInfoFetching;
export const isDeviceInfoSuccess = (state) => state.deviceInfo.deviceInfoSuccess;
export const isDeviceInfoFail = (state) => state.deviceInfo.deviceInfoFail;
export const getDeviceInfo = (state) => state.deviceInfo.deviceInfo;
export const isUserDeviceInfoFetching = (state) => state.deviceInfo.userDeviceInfoFetching;
export const isUserDeviceInfoSuccess = (state) => state.deviceInfo.userDeviceInfoSuccess;
export const isUserDeviceInfoFail = (state) => state.deviceInfo.userDeviceInfoFail;
export const getUserDeviceInfo = (state) => state.deviceInfo.userDeviceInfo;
export const isRemovingDevice = (state) => state.deviceInfo.isRemovingDevice;
export const isRemoveDeviceSuccess = (state) => state.deviceInfo.removeDeviceSuccess;
export const isRemoveDeviceFail = (state) => state.deviceInfo.removeDeviceFail;
export const getDeviceInfoByVersionPk = (state) => state.deviceInfo.deviceInfoByVersionPk;

const handlers = {
    [FETCH_DEVICE_INFO_START]: deviceInfoFetching,
    [FETCH_DEVICE_INFO_SUCCESS]: deviceInfoFetchFinished(true),
    [FETCH_DEVICE_INFO_FAIL]: deviceInfoFetchFinished(false),
    [REMOVE_DEVICE_START]: (state) => ({
        ...state,
        removingDevice: true
    }),
    [REMOVE_DEVICE_SUCCESS]: (state) => ({
        ...state,
        removingDevice: false,
        removeDeviceSuccess: true,
        removeDeviceFail: false
    }),
    [REMOVE_DEVICE_FAIL]: (state) => ({
        ...state,
        removingDevice: false,
        removeDeviceSuccess: false,
        removeDeviceFail: true
    }),
    [FETCH_USER_DEVICE_INFO_START]: userDeviceInfoFetching,
    [FETCH_USER_DEVICE_INFO_SUCCESS]: userDeviceInfoFetchFinished(true),
    [FETCH_USER_DEVICE_INFO_FAIL]: userDeviceInfoFetchFinished(false),

    [FETCH_DEVICE_INFO_BY_DEVICE_VERSION_PK_START]: deviceInfoByVersionPkFetching,
    [FETCH_DEVICE_INFO_BY_DEVICE_VERSION_PK_SUCCESS]: deviceInfoByVersionPkFinished(true),
    [FETCH_DEVICE_INFO_BY_DEVICE_VERSION_PK_FAIL]: deviceInfoByVersionPkFinished(false)
};

export default function deviceInfo(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
